<template>
    <Vue2DatePicker
        :input-attr="{ id }"
        v-model="internalValue"
        format="DD/MM/YYYY"
        valueType="format"
    />
</template>

<script>
    import Vue2DatePicker from 'vue2-datepicker';
    import 'vue2-datepicker/index.css';
    import 'vue2-datepicker/locale/fr';

    export default {
        name: 'DatePicker',
        props: {
            value: {
                type: [String, Date],
                default: null
            },
            id: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                internalValue: this.value
            };
        },
        watch: {
            internalValue(newVal) {
                this.$emit('input', newVal);
            },
            value(newVal) {
                this.internalValue = newVal;
            }
        },
        components: { Vue2DatePicker }
    };
</script>